export const removeMarkdown = (text: string): string =>
  text
    .replace(/[#_*~>`]/g, "")
    .replace(/\[.*?\]\(.*?\)/g, "")
    .replace(/!\[.*?\]\(.*?\)/g, "")
    .replace(/`{1,3}.*?`{1,3}/g, "")
    .replace(/\n+/g, " ");